// Opens the existing Crane / Recovery / Legal create modal, prefilled from an
// accident case and linked to it via accidentCaseNo.
// Used by: CreateCaseModal (success screen) and OnSpotServicesTab (case detail).
//
// Both modals must accept the new optional props `prefill` and `accidentCaseNo`
// (added in the next steps). Without those props they behave exactly as before.
import { createPortal } from "react-dom";
import CreatecraneServiceModal from "../../../../Pages/AdminWorkshopPanel/QuickServices/CreatecraneServiceModal";
import CreateLegalCaseModal from "../../../../Pages/AdminWorkshopPanel/QuickServices/Legal/CreateLegalCaseModal";

import { SERVICE_TARGET, craneDefaults, legalDefaults } from "./CaseServiceAdapters";

export default function LinkedServiceLauncher({
  type,             // SERVICE_CATALOG type: "CRANE" | "TOWING_VAN" | "ADVOCATE"
  caseInfo,         // shaped like useCaseDetail().caseInfo
  accidentDetails,  // shaped like useCaseDetail().accidentDetails (may be null)
  onClose,
  onCreated,        // called with `type` after a request is created
}) {
  const target = SERVICE_TARGET[type];
  if (!target || !caseInfo) return null;

  const modal =
    target.kind === "quick" ? (
      <CreatecraneServiceModal
        serviceType={target.serviceType}            // "crane" | "recovery"
        accidentCaseNo={caseInfo.accidentCaseNo}
        prefill={craneDefaults(caseInfo, accidentDetails)}
        onClose={onClose}
        onCreated={() => onCreated?.(type)}
      />
    ) : (
      <CreateLegalCaseModal
        accidentCaseNo={caseInfo.accidentCaseNo}
        prefill={legalDefaults(caseInfo, accidentDetails)}
        onClose={onClose}
        onCreated={() => onCreated?.(type)}
      />
    );
    return createPortal(
    <div style={{ position: "relative", zIndex: 3000 }}>{modal}</div>,
    document.body
  );
}